export default __webpack_public_path__ + "static/media/logo_alma_laurea.87d3f863.png";